import { sortByOrder } from '../../../provider/utility';

export const convertWorkshopLevelsToRobotAccordion = (wsLevels) =>
  sortByOrder(
    wsLevels.map((lvl) => ({
      ...lvl,
      type: 'robot',
      value: lvl.id,
      title: lvl.name,
    })),
  );

export const convertWorkshopLevelsToRobotAccordionWithSpecialPrice = (wsLevels, availableWorkshopsCurrentLocation) => {

  if(availableWorkshopsCurrentLocation !== null) {
    let specialPrices = new Map();

    for (let i = 0; i < availableWorkshopsCurrentLocation.length; i++) {
      specialPrices.set(availableWorkshopsCurrentLocation[i].workshop_type_id, availableWorkshopsCurrentLocation[i].special_price);
    }

    return sortByOrder(
      wsLevels.map((lvl) => ({
        ...lvl,
        price: specialPrices.get(lvl.id) ?? lvl.price,
        type: 'robot',
        value: lvl.id,
        title: lvl.name,
      })),
    );
  }


  return sortByOrder(
    wsLevels.map((lvl) => ({
      ...lvl,
      type: 'robot',
      value: lvl.id,
      title: lvl.name,
    })),
  );
};

export const filterByAge = (wsLevels, age) =>
  wsLevels.filter((robot) =>
    robot.age_int?.length > 0 ? robot.age_int.includes(age) : true,
  );
